import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import CloseX from '../../../shared/icons/icon-close-modal.svg';
import { styler } from '../../helpers/classNameHelper';
import ImageSlider from '../ImageSlider/ImageSlider';
import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import useSwipe from '../../../hooks/useSwipe';


const ImageModel = (props) => {
  const {
    imgUrl,
    children,
    isOpen,
    onRequestClose,
    styleFlag,
    imgArray,
    handleNext,
    handlePrev,
    getVisibleImages,
    activeIndex,
    currentIndex,
    visibleImages,
    handleThumbnailClick,
    totalImages,
    isArrowVisible
  } = props;

  const style = styler(styleFlag);
  const [modalIsOpen, setModalIsOpen] = useState();
  const handlers = useSwipe(handleNext, handlePrev)

  const [scale, setScale] = useState(false);

  function doubleTapToZoom(zoomIn, zoomOut) {
    scale ? zoomOut() : zoomIn();
    setScale(prev => !prev);
  }
  const appElement = document.body.querySelector('.se-page');
  const modalProps = {
    ariaHideApp: !!appElement,
    appElement,
  };

  useEffect(() => {
    if (isOpen !== null && modalIsOpen !== isOpen) {
      setModalIsOpen(isOpen);
    }
  }, [isOpen]);

  

  const openModal = (event) => {
    event.stopPropagation();
    event.preventDefault();

    const { disabled } = props;

    if (disabled) {
      return;
    }

    setModalIsOpen(true);
  };

  const closeModal = (event) => {
    event.stopPropagation();
    event.preventDefault();

    setModalIsOpen(false);
  };

  function resetScale(){
    setScale(false);
  }
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      zIndex:100
      
    },
  };

  const transformComponentRef = useRef(null);
  const closeHandler = onRequestClose || closeModal;



  return (
    <>
      {children && (
        <div
          className={style('image-modal__trigger')}
          tabIndex="0"
          onClick={openModal}
        >
          {children}
        </div>
      )}
      <Modal
        className={style('image-modal')}
        isOpen={modalIsOpen}
        onRequestClose={closeHandler}
        overlayClassName="image-modal__overlay"
        {...modalProps}
        style={customStyles}
       
      >
        <div
          role="button"
          aria-label="Close"
          tabIndex="0"
          className="image-modal__close"
          onClick={closeHandler}
        >
          <CloseX className="image-modal__close--icon" />
        </div>
        <TransformWrapper
          doubleClick={{ disabled: true }}
          initialScale={1}
          disablePadding={true}
          ref={transformComponentRef}
          wheel={{ disabled: true }}

        >
          {({ zoomIn, resetTransform }) => (
            <section  {...handlers} className='image-modal__main-section'>
              <span className='modal-top-line-text'>Double tap or pinch to zoom</span>
              <div  className='image-modal__zoomed-image'>
                <TransformComponent>
                  <div className='zoomed-image-container' onDoubleClick={() => { doubleTapToZoom(zoomIn, resetTransform) }}>
                    <img src={imgUrl.url} alt={imgUrl.alt} ref={transformComponentRef} />
                  </div>
                </TransformComponent>

              </div>
              <span className='image-modal__current-step'>
                {activeIndex + 1} of {totalImages}
              </span>
              <div className='image-modal__image-slider'>
                <ImageSlider
                  images={imgArray}
                  handleNext={handleNext}
                  handlePrev={handlePrev}
                  getVisibleImages={getVisibleImages}
                  activeIndex={activeIndex}
                  currentIndex={currentIndex}
                  visibleImages={visibleImages}
                  handleThumbnailClick={handleThumbnailClick}
                  totalImages={totalImages}
                  isArrowVisible={isArrowVisible}
                  resetTransform={resetTransform}
                  resetScale={resetScale}
                />
              </div>
            </section>
          )}
        </TransformWrapper>
      </Modal>
    </>
  );
};

ImageModel.propTypes = {
  imgUrl: PropTypes.shape({
    url:PropTypes.string.isRequired,
    alt:PropTypes.string.isRequired,
    title:PropTypes.string.isRequired
  }),
  styleFlag: PropTypes.string.isRequired,
};

ImageModel.defaultProps = {
  children: null,
  styleFlag: '',
  
};

export default ImageModel;
